var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sportFootballMatchStatusSettingsItems"},[_c('el-radio-group',{model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}},_vm._l((_vm.statuses),function(item){return _c('status-settings-item',{key:item.id,attrs:{"status":item,"match":_vm.match},on:{"update":_vm.updateDate}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }